'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { connect, useDispatch } from 'react-redux';
import { Map as ImmutableMap } from 'immutable';
import UIFlex from 'UIComponents/layout/UIFlex';
import Banners from 'AdsUI/components/Banners';
import BannerTypes from 'AdsUI/lib/BannerTypes';
import { removeHeaderBanner } from 'AdsUI/actions/BannerActions';
import { deleteErrorAlert } from 'AdsUI/actions/LeadSyncingActions';
import { usageTracker } from 'AdsUI/lib/usageTracker';

const HeaderBannerContainer = (_ref) => {
  let {
    header: {
      banners,
      options = ImmutableMap()
    }
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["header"]);

  const dispatch = useDispatch();

  if (!banners || banners.isEmpty()) {
    return null;
  }

  const onCloseBanner = bannerType => {
    if (bannerType === BannerTypes.LEAD_SYNC_ERROR_ALERT) {
      usageTracker.track('leadSyncingAction', {
        action: 'dismiss-errors',
        context: 'error-banner'
      });
      dispatch(deleteErrorAlert());
    } else if (bannerType === BannerTypes.LEAD_SYNC_WARNING_ALERT) {
      usageTracker.track('leadSyncingAction', {
        action: 'dismiss-warnings',
        context: 'warning-banner'
      });
      dispatch(deleteErrorAlert());
    }
  }; // no usage of `page` in `addHeaderBanner()`. related code from PR-1222
  // has been removed


  const bannerTypes = banners.keySeq();
  const bannersToDisplay = bannerTypes.toJS().map(bannerType => {
    const SpecificBanner = Banners[bannerType];
    const bannerOptions = options.has(bannerType) ? options.get(bannerType) : {};
    return /*#__PURE__*/_jsx(SpecificBanner, Object.assign({}, bannerOptions, {
      onClose: () => {
        onCloseBanner(bannerType);
        props.removeHeaderBanner(bannerType);
      }
    }), bannerType);
  });

  if (bannersToDisplay.length > 1) {
    // Display all banners
    return /*#__PURE__*/_jsx(UIFlex, {
      direction: "column",
      style: {
        width: '100%'
      },
      children: bannersToDisplay.map((banner, index) => /*#__PURE__*/_jsx("div", {
        className: "m-y-2",
        style: {
          width: '100%'
        },
        children: banner
      }, `banner-${index}`))
    });
  } else if (bannersToDisplay.length === 1) {
    // Display only one banner
    return bannersToDisplay[0];
  } else {
    return null;
  }
};

export default connect(state => ({
  header: state.banners.header
}), {
  removeHeaderBanner
})(HeaderBannerContainer);